import { Graphics2D } from './java/Graphics2D';
import { GameObject } from './GameObject';
import { ID } from './ID';
import { TrailPool } from './TrailPool';

export class Handler {
  private objects: GameObject[] = [];
  private toRemove = new Set<GameObject>();

  spd = 6;

  tick(): void {
    for (let i = 0; i < this.objects.length; i++) {
      this.objects[i].tick();
    }
    this.flushRemoves();
  }

  render(g: Graphics2D): void {
    for (let i = 0; i < this.objects.length; i++) {
      this.objects[i].render(g);
    }
  }

  clearEnemys(): void {
    this.objects = this.objects.filter(
      (obj) => obj.getId() === ID.Player || obj.getId() === ID.PlayerProjectile,
    );
    this.toRemove.clear();
    TrailPool.clear();
  }

  addObject(object: GameObject): void {
    this.objects.push(object);
  }

  removeObject(object: GameObject): void {
    this.toRemove.add(object);
  }

  flushRemoves(): void {
    if (this.toRemove.size > 0) {
      this.objects = this.objects.filter((o) => !this.toRemove.has(o));
      this.toRemove.clear();
    }
  }

  /** Live array — callers mutate it directly, as the Java code does with getObjects(). */
  getObjects(): GameObject[] {
    return this.objects;
  }

  /** Java's `objects.removeIf(pred)`. */
  removeIf(pred: (o: GameObject) => boolean): void {
    this.objects = this.objects.filter((o) => !pred(o));
  }

  clear(): void {
    this.objects.length = 0;
    this.toRemove.clear();
  }
}
